export default {
    _toggle   : null,
    _targets  : null,
    _index    : 0,
    _toggleTag: 'data-toggle-articles',
    _targetTag: 'data-target-articles',
    init() {
        this._toggle  = document.querySelector(`[${this._toggleTag}]`);
        this._targets = document.querySelectorAll(`[${this._targetTag}]`);
        
        if (!this._toggle || !this._targets) {
            return;
        }
        
        this._length = Number(this._toggle.getAttribute(this._toggleTag));
        this._toggle.addEventListener('click', () => {
            this._index++;
            for (const target of this._targets) {
                const id = Number(target.getAttribute(this._targetTag));
                if (id === this._index) {
                    target.classList.remove('news__list--hidden');
                }
            }
            if (this._index === this._length - 1) {
                this._toggle.classList.add('news__toggle--hidden');
            }
        });
    }
}